export const ADVERTISING_TARGET = 'target';
export const DYNAMIC_CONDITIONS_TARGET = 'dynamicTarget';
export const CREATIVES_TARGET = 'creativesTarget';

export const CONDITION_TYPE = 'type';
export const DYNAMIC = 'Dynamic';

export const AFFECTED_LEVEL = 'dimension';
export const SECONDARY_AFFECTED_LEVEL = 'secondaryDimension';

export const SCHEDULE = 'schedule';
export const ACTION = 'action';
export const CONDITIONS = 'conditions';
export const NOTIFICATIONS = 'notifications';
export const EXTRA_METRICS = 'extraMetrics';
